const body = document.body;

/**
 * Make image teasers fully clickable.
 *
 */
const imageTeasersWithoutLink = document.querySelectorAll('div.image-with-text-overlay__wrap');
imageTeasersWithoutLink.forEach((teaser) => {
  const link = teaser.querySelector('.image-with-text-overlay__button');
  if (link) {
    const target = link.getAttribute('href');
    teaser.style.cursor = 'pointer';
    teaser.addEventListener('click', () => {
      window.location.href = target;
    });
  }
});

if (body.classList.contains('template-product')) {
  const gallery = document.querySelector('.image-gallery');
  if (gallery) {
    gallery.querySelectorAll('.gallery-item__caption .onboarding-svg').forEach((item) => {
      const itemNode = item.closest('.gallery-item');
      itemNode.parentNode.removeChild(itemNode);
    });
    if (gallery.childElementCount === 0) {
      gallery.parentNode.removeChild(gallery);
    }
  }
}